import { connect } from 'react-redux';
import getRx from '../../actions/userInformation/setRx';
import LookupLayout from './LookupLayout';
import setRxFormValues from '../../actions/userInformation/setRxFormValues';

export default connect(null, {
  getRxConnect: getRx,
  setRxFormValues,
})(LookupLayout);



// WEBPACK FOOTER //
// ./src/containers/HomePage/Lookup.js